import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// CSS
import "./popup.css";

function Popup() {
  const [mobilenumber, setMobileNumber] = useState();

  const location = useLocation();

  

  useEffect(() => {
    if(location.pathname.includes("/lp6/fb/")){
      setMobileNumber("898 898 9393");
    }else if(location?.pathname?.includes("/lp2/") || location?.pathname?.includes("/lp/") || location?.pathname?.includes("/lp5/") || location?.pathname?.includes("/lp6/") || location?.pathname?.includes("/lp8/") || location?.pathname?.includes("/affiliate/") || location?.pathname?.includes("/lp9/")){
      setMobileNumber("898 898 8585");
    }else {
      setMobileNumber("898 898 8787");
    }
  }, []);
  
  return (
    <div className="main_container">
      <div className="popup_container">
        <div className="popup_sec1">
          <div className="popup_sec1Logo">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/119541da-addd-4248-a768-913ca17b433d.png"
              alt="Redcliffe Logo"
            />
          </div>
          <div className="popup_sec1Text">
            <p>
              Didn't find
              <br /> the test you are
              <br /> looking for?
            </p>
          </div>
        </div>

        <div className="popup_sec2">
          <div className="popup_sec2Cards">
            <div className="popup_sec2Card">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/748fbd16-bd3d-42cf-b908-f3a9218e6776.svg"
                alt="Home Icon"
              />
              <p className="sec2card_Heading">3500+</p>
              <p className="sec2card_Para">Tests Available</p>
            </div>

            <div className="popup_sec2Card">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5b521c28-3e83-4de2-919a-0434b49fbfa0.svg"
                alt="Delivery Man"
              />
              <p className="sec2card_Heading">Free</p>
              <p className="sec2card_Para">
                Home Sample
                <br /> Collection
              </p>
            </div>

            <div className="popup_sec2Card">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/4de6b783-86f3-4919-b59d-c6dc59ceb58e.svg"
                alt="Offer Icon"
              />
              <p className="sec2card_Heading">Upto 50%</p>
              <p className="sec2card_Para">
                Discount on
                <br /> all tests
              </p>
            </div>
          </div>

          <div className="popup_sec2Btn">
            <p>To book tests today!</p>
            <a href={`tel:+91 ${mobilenumber}`} className="sec2CallBtn">
              Call {mobilenumber}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Popup));
